export enum PRODUCTS_SDK_METHODS {
    GET_PRODUCTS_STACK = "getProductsStack",
}
